import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '@scentregroup/ui'
import { displayStringForPriceRange } from '../../helpers/product-price'
import style from './index.module.scss'

interface IWestfieldProduct {
  objectID: string
  name: string
  description: string
  minPrice: number
  maxPrice: number
  image: string
  href: string
}

export interface IWestfieldProductCardProps {
  westfieldProduct: IWestfieldProduct
  mkpCartCount: number
  onClick?: () => void
}

const cloudinaryPrefix = `https://res.cloudinary.com/scentre-group-au/image/fetch/`

const WestfieldProductCard: React.FunctionComponent<IWestfieldProductCardProps> = ({
  westfieldProduct,
  mkpCartCount,
  onClick,
}) => {
  let url = westfieldProduct.href
  if (westfieldProduct.objectID === 'physical-gift-card') {
    url += `?wd=${mkpCartCount > 0 ? 1 : 0}`
  }

  return (
    <div className={style.westfieldProductCard}>
      <Link
        className={style.westfieldProductLinkWrapper}
        to={url}
        onClick={() => (onClick ? onClick() : null)}
      >
        <Image
          className={style.westfieldProductImage}
          imageUrl={`${cloudinaryPrefix}${westfieldProduct.image}`}
          alt={westfieldProduct.name}
          ratio="poster"
          bgSize="contain"
          type="mobile"
        />
        <div className={style.westfieldProductName}>
          {westfieldProduct.name}
        </div>
        <div className={style.price}>
          {displayStringForPriceRange({
            min: westfieldProduct.minPrice,
            max: westfieldProduct.maxPrice,
          })}
        </div>
        <div className={style.westfieldProductDescription}>
          {westfieldProduct.description}
        </div>
      </Link>
    </div>
  )
}

export default WestfieldProductCard
